import React, { useEffect, useState } from "react";
import axios from "axios";
import "./player_ranking.styles.css";
import RankingFilter from "./player_ranking_filter";
import RankingTable from "./player_ranking_table";
import usePlayerData from "../../hooks/usePlayerData";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Tooltip,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";

export default function PlayerRankingMainSection() {
  const [errorMsg, setErrorMsg] = useState("");
  const { setData } = usePlayerData();
  const [isLoading, setIsLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);

  const API_URL = "https://badmintonnepal.org/api/admin/getPlayers";
  // const API_URL = "http://localhost:8006/api/admin/getPlayers";

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(API_URL, {
          withCredentials: true,
        });
        if (response.status === 200) {
          setData(response.data);
          setErrorMsg("");
        }
      } catch (err) {
        if (err.response) {
          setErrorMsg(err.response.data.message);
        } else {
          setErrorMsg(err.message);
        }
        console.log(err);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [setData]);

  // Handler to toggle filter visibility
  const handleToggleFilter = () => {
    setFilterStatus((prevStatus) => !prevStatus);
  };

  return (
    
      <Box className="ranking__content"
        sx={{
          display: "flex",
          // flexDirection: { xs: "column", sm: "row" },
          width: "94%",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb:1,
          pt:2,
          // minHeight:"100vh"
        }}
      >
        {/* Header Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection:"row",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
            // border:"1px solid black",
            width: "100%"
          }}
        >
          <Typography
            component="h3"
            variant="h5"
            sx={{
              fontFamily: "Roboto-serif",
              fontWeight: "600",
              fontSize:{xs:"16px",sm:"22px"}
            }}
          >
            Player Ranking List
          </Typography>

          {/* Filter Toggle Button */}
          <Tooltip title={filterStatus ? "Hide Filter" : "Show Filter"}>
            <Button
              variant={filterStatus ? "contained" : "outlined"}
              // color="primary"
              startIcon={
                filterStatus ? <FilterListOffIcon /> : <FilterListIcon />
              }
              onClick={handleToggleFilter}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                height: 36,
                px: 2,
                color:"white"
              }}
            >
              {filterStatus ? "Hide Filter" : "Filter"}
            </Button>
          </Tooltip>
        </Box>

        {/* Loading Overlay */}
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(7, 7, 7, 0.04)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <CircularProgress sx={{ color: "#861ED8" }} />
          </div>
        )}

        {/* Main Content / Error Handling */}
        {errorMsg ? (
          <Box sx={{ color: "error.main", mt: 2 }}>
            <Typography variant="h6">Unable to fetch data</Typography>
            <Typography variant="body2">{errorMsg}</Typography>
          </Box>
        ) : (
          <Box>
            {/* Conditional Filter Component */}
            {filterStatus && (
              <Box sx={{ mb: 1 }}>
                <RankingFilter changeFilterStatus={setFilterStatus} />
              </Box>
            )}

            {/* Ranking Table Component */}
            <RankingTable changeFilterStatus={setFilterStatus} />
          </Box>
        )}
      </Box>
  );
}